import { render } from "./TabsPage.vue?vue&type=template&id=8eb1d1fa&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/simon/projects/farmlink-poly/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__